// src/components/invoice_terms/InvoiceTermRow.js
import React from "react";
import { Row, Col } from "react-bootstrap";
import InvoiceStatusButtons from "./InvoiceStatusButtons";
import moment from "moment/moment";
import {euroFormat} from "../../../utils/usefullFunctions";

const InvoiceTermRow = ({ project, term, user, dashboard = false }) => {
    const originalProject = project.original || project; // Use original data if formatted

    return (
        <Row key={term.projects_invoice_terms_id} className="d-flex p-2">
            {dashboard ? (
                <Col>
                    <a href={`/project/${originalProject.project_id}`}>
                        {originalProject.project_name}
                    </a>
                </Col>
            ) : null}
            <Col className="d-flex align-items-center justify-content-center d-20-left">

                <InvoiceStatusButtons
                    status={term.projects_invoice_terms_status}
                    plannedFor={term.projects_invoice_terms_planned_for}
                    project={project}
                    invoice={term}
                    isForExcelExport={true}
                    user={user}
                />
            </Col>
            <Col sm="11 d-80-right">
                <strong>{term.projects_invoice_terms_commentary}</strong>
                <br/>
                <small className="text-muted d-block">
                    {moment(term.projects_invoice_terms_planned_for).format("DD MMMM YYYY")}
                </small>
                <small className="text-muted d-block">
                    <strong>{euroFormat(term.projects_invoice_terms_invoice_amount)}</strong>
                </small>
            </Col>
        </Row>
    );
};

export default InvoiceTermRow;
